// Bootstrap breakpoints
const SM_SCREEN = 576;
const MD_SCREEN = 768;
const LG_SCREEN = 992;
const XL_SCREEN = 1200;
const XXL_SCREEN = 1400;

// Mui breakpoints
const MUI_XS_SCREEN = 0;
const MUI_SM_SCREEN = 600;
const MUI_MD_SCREEN = 900;
const MUI_LG_SCREEN = 1200;
const MUI_XL_SCREEN = 1536;

// Elements
const sidebarWidth = 285;

// Clink Project navbar
const XLH_SCREEN = 1300;

const dimensions = {
  SM_SCREEN,
  MD_SCREEN,
  LG_SCREEN,
  XL_SCREEN,
  XXL_SCREEN,
  adminsidebarWidth: sidebarWidth,
  XLH_SCREEN,
  MUI_XS_SCREEN,
  MUI_SM_SCREEN,
  MUI_MD_SCREEN,
  MUI_LG_SCREEN,
  MUI_XL_SCREEN,
};

module.exports = dimensions;
